<template>
    <div>404页面</div>
</template>

<script>
    export default {
        name: "404.vue"
    }
</script>

<style scoped>

</style>
